












































import { Component, Vue } from "vue-property-decorator";
import AuthApi from "@/services/AuthApi";
import { ResetPasswordBody } from "@/api/lab-base-api-client";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class EmailForm extends Vue {
  // 入力フォーム初期値
  private form: ResetPasswordBody = {
    email: "",
    confirmEmail: "",
  };

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // 「送信」clickで実行
  private async submit() {
    try {
      if (this.$route.name === "MResetPass") {
        await this.adminResetPass();
      } else if (this.$route.name === "UResetPass") {
        await this.userResetPass();
      } else {
        await this.organizationAdminResetPass();
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // userパスワードリセットメール送信
  private async userResetPass() {
    this.form.confirmEmail = this.form.email;
    await AuthApi.instance.resetUserPassword(this.form);
    this.$router.push({ name: "UResetPassEmail" });
  }

  // adminパスワードリセットメール送信
  private async adminResetPass() {
    this.form.confirmEmail = this.form.email;
    await AuthApi.instance.resetAdminPassword(this.form);
    this.$router.push({ name: "MResetPassEmail" });
  }

  // organizationAdminパスワードリセットメール送信
  private async organizationAdminResetPass() {
    this.form.confirmEmail = this.form.email;
    await AuthApi.instance.resetOrganizationAdminPassword(this.form);
    this.$router.push({ name: "OResetPassEmail" });
  }
}
